module.exports = __webpack_public_path__ + "img/어쌔신.9d89acea.png";